// JsFromRoutes CacheKey 98e603596e1b0c2d2196a425f11ea034
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/add-contact/prompts'),
  sendTestEmail: /* #__PURE__ */ definePathHelper('post', '/add-contact/prompts/send_test_email'),
}
